import { DataGrid, GridColumns } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
// import { Data } from "react-csv/components/CommonPropTypes";
import Forecast from "../../components/classes/Forecast";
import ForecastEstoqueConsumido from "../../components/classes/ForecastEstoqueConsumido";
import ForecastDataSet from "../../components/data/ForecastDataSet";

import { useTranslation } from "react-i18next";

type Data = Array<Record<string, any>>;

export default function ForecastModalGrid(props: ForecastGridModalPropsTypes) {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(true);
  const [pageSize, setPageSize] = useState(50);

  const [forecastEstoqueConsumido, setForecastEstoqueConsumido] = useState<
    ForecastEstoqueConsumido[]
  >([]);
  const [rows, setRows] = useState<Data>([]);
  const columns: GridColumns = createColumns();

  const dataForecast: ForecastDataSet = new ForecastDataSet();

  useEffect(() => {
    if (props.forecasts) {
      fetchData(props.forecasts);
    }
  }, [props.forecasts]);

  async function fetchData(forecasts: Forecast[]) {
    let forecastEstoqueConsumidoArr: ForecastEstoqueConsumido[] = [];
    for await (const item of forecasts) {
      let forecastEstoque = new ForecastEstoqueConsumido(
        item.id,
        item.codigoFornecedorSap,
        item.numeroContrato,
        item.idSku,
        item.centro,
        item.quantidade,
        item.anoMesRef
      );
      await dataForecast
        .obterPercentualConsumido(forecastEstoque)
        .then((percentual) => {
          forecastEstoque.setPercentualConsumido(percentual);
          forecastEstoqueConsumidoArr.push(forecastEstoque);
        });
    }
    setForecastEstoqueConsumido(forecastEstoqueConsumidoArr);
    fillTable(forecastEstoqueConsumidoArr);
    setLoading(false);
  }

  function createColumns(): GridColumns {
    let cols: GridColumns = [
      {
        field: "id",
        headerName: "#",
        width: 80,
        align: "center",
        headerAlign: "center",
      },
      {
        field: "codigoFornecedorSap",
        headerName: t("pages.monthlyForecast.text.sAPSupplierCode"),
        minWidth: 180,
        align: "center",
        headerAlign: "center",
      },
      {
        field: "numeroContrato",
        headerName: t("pages.monthlyForecast.text.contractNumber"),
        type: "string",
        minWidth: 180,
        editable: false,
        align: "center",
        headerAlign: "center",
      },
      {
        field: "codigoSku",
        headerName: t("common.sku"),
        type: "string",
        minWidth: 110,
        editable: false,
        align: "center",
        headerAlign: "center",
      },
      {
        field: "centro",
        headerName: t("common.center"),
        type: "string",
        minWidth: 240,
        editable: false,
        align: "center",
        headerAlign: "center",
      },

      {
        field: "percentualConsumido",
        headerName: t("pages.monthlyForecast.text.percentageConsumed"),
        type: "string",
        minWidth: 180,
        editable: false,
        align: "center",
        headerAlign: "center",
        renderCell: (item) => {
          return <p>{item.row.percentualConsumido}%</p>;
        },
      },
      {
        field: "quantidade",
        headerName: t("common.quantity"),
        type: "string",
        minWidth: 110,
        editable: false,
        align: "center",
        headerAlign: "center",
      },
    ];
    return cols;
  }

  function fillTable(dados: ForecastEstoqueConsumido[]) {
    let gridData: Data = [];
    dados.forEach((item: ForecastEstoqueConsumido) => {
      gridData.push(JSON.parse(ForecastEstoqueConsumido.toJson(item)));
    });
    setRows(gridData);
  }

  return (
    <>
      <div className="divFlow">
        <div style={{ height: "50vh", minWidth: "100%" }}>
          <DataGrid
            loading={loading}
            rows={rows}
            columns={columns}
            rowsPerPageOptions={[50, 100, 250, 500]}
          />
        </div>
      </div>
    </>
  );
}

interface ForecastGridModalPropsTypes {
  forecasts?: Forecast[];
}
